export default __webpack_public_path__ + "static/media/login-05.d869704b.jpg";